import React, { useEffect, useState } from 'react'
import ItemsApp, { EmptyItemModel, IItemModel } from './ItemsApp'
import { useNavigate, useParams } from 'react-router-dom'
import { addNewItem, deleteItem, updateSingleItemPageForceRefresh, useReturnSingleItem, useReturnSingleItemByUniqueId } from './itemsSlice'
import { useDispatch } from 'react-redux'
import { updateGlobalLoaderStatus, updateQuickNotificationDetails, useReturnGlobalLoaderStatus } from '../notifications/notificationsSlice'
import { handleRequestError } from '../../services/api'
import PageHeadSection from '../admin/components/PageHeadSection'
import NothingFound from '../../components/NothingFound'
import NotFound from '../../components/NotFound'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import SingleItemContent from './SingleItemContent'
import { IBasicDataViewItem } from '../../components/DataDisplayer/BasicDataViewer'
import { useSelector } from 'react-redux'
import { RootState } from '../../app/store'
import { useReturnCurrentUser } from '../user/userSlice'
import BasicModalWindow from '../../components/BasicModalWIndow'

interface IProps {
    useUniqueId?: boolean,
    disablePageHeadSection?: boolean,
    usePublicDetails?: boolean,
    customId?: number,
}

export default function ViewSingleItemPage(props: IProps) {

    const { useUniqueId, disablePageHeadSection, usePublicDetails, customId } = props

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const params = useParams()
    const itemsApp = new ItemsApp()

    const { forceSingleItemPageRefresh } = useSelector((state: RootState) => state.items)

    const itemId = customId ? customId : params.id ? Number(params.id) : 0
    const getUniqueId: string = params.unique_id ? params.unique_id : ""

    // const itemFromState = useReturnSingleItem(itemId)

    const itemByUniqueId = useReturnSingleItemByUniqueId(getUniqueId)
    const itemById = useReturnSingleItem(itemId)

    const item = useUniqueId ? itemByUniqueId : itemById

    // const [item, setItem] = useState<IItemModel>(EmptyItemModel)
    const [notFound, setNotFound] = useState<boolean>(false)

    const [undoTimeout, setUndoTimeout] = useState<NodeJS.Timeout | null>(null)
    const [basicDataViewerItems, setBasicDataViewerItems] = useState<IBasicDataViewItem[]>([])

    const uploadLoader = (status: boolean) => dispatch(updateGlobalLoaderStatus({ status: status }))
    const loading = useReturnGlobalLoaderStatus()

    const currentUser = useReturnCurrentUser()
    const [managePersmission, setManagePersmission] = useState<boolean>(false)

    const [sureToDeleteWindow, setSureToDeleteWindow] = useState<boolean>(false)

    /**
     * Reset force refresh
     */
    const handleResetItemForceRefresh = () => dispatch(updateSingleItemPageForceRefresh(false))

    /**
     * Load item
     */
    const loadItem = (byUniqueId?: boolean, customUniqueId?: string) => {
        uploadLoader(true)

        let func =  itemsApp.singleInstanceDetails(itemId)

        // if (itemsApp.validateUniqueId(getUniqueId)){
        //     console.log("valid unique id", getUniqueId)
        // }else{
        //     console.log("invalud unique id", getUniqueId)
        // }

        if (byUniqueId){
            func = itemsApp.singleItemDetailsByUniqueId(customUniqueId ? customUniqueId : getUniqueId, usePublicDetails)
        }

        func
            .then(response => {

                const result: IItemModel = response.data
                // setItem(result)

                dispatch(addNewItem(result))

                setNotFound(false)
                uploadLoader(false)
                handleResetItemForceRefresh()

            })
            .catch(error => {

                const { status } = error.response

                handleRequestError(error, dispatch)

                if (status == 404){
                    setNotFound(true)
                }

                uploadLoader(false)
                handleResetItemForceRefresh()

            })
    }

    /**
     * Handle before delete
     */
    const handleBeforeDelete = () => {
        setNotFound(false)

        if (undoTimeout){
            clearTimeout(undoTimeout)
        }
    }

    /**
     * Delete item
     */
    const handleDeleteItem = () => {
    

        setNotFound(true)
        setSureToDeleteWindow(false)

        updateQuickNotificationDetails(true, "Item has been deleted", "error", dispatch, () => {}, 5000, false, [
            {
                label: "Close",
                handleClose: true
            },
            // {
            //     label: "Undo",
            //     handleClose: false,
            //     onClick: () => handleBeforeDelete()
            // }
        ])

        // const timeout = setTimeout(() => {
        //     itemsApp.deleteInstance(item.id)
        //         .then(response => {
        //             dispatch(deleteItem({ id: item.id }))
        //             navigate("/panel/items")
        //         })
        //         .catch(error => {
        //             handleRequestError(error, dispatch)
        //         })
        // }, 5000);
    
        // setUndoTimeout(timeout);

    }

    const handleLoadItem = () => {
        if (useUniqueId){
            if (item.unique_id !== getUniqueId){
                loadItem(true)
            }
        }else{

            if (itemsApp.validateUniqueId(params.id ? params.id : "")){
                loadItem(true, params.id)
            }else{
                if (itemId){    
                    if (item.id !== itemId){
                        loadItem()
                    }
                }
            }
        }
    }

    /**
     * Load item
     */
    useEffect(() => {
        handleLoadItem()
    }, [itemId])

    useEffect(() => {
        if (forceSingleItemPageRefresh){
            handleLoadItem()
        }
    }, [forceSingleItemPageRefresh])

    useEffect(() => {
        if (currentUser.is_superuser || currentUser.is_daemon){
            setManagePersmission(true)
        }
    }, [currentUser])

    return(
        <div>

            <BasicModalWindow
                shown={sureToDeleteWindow}
                size="sm"
                title="Delete item"
                showHeader
                actionButtons={[
                    {
                        color: "error",
                        label: "Cancel",
                        onClick: () => setSureToDeleteWindow(false)
                    },
                    {
                        color: "success",
                        label: "Delete",
                        onClick: () => handleDeleteItem()
                    }
                ]}
                actionButtonsBottom
                handleClose={() => setSureToDeleteWindow(false)}
            >
                <p>{!notFound ? item.title ? `Are you sure that you want to delete '${item.title}'` : "Are you sure that you want to delete this item?" : "---"}</p>
            </BasicModalWindow>

           {!disablePageHeadSection && <PageHeadSection 
                pageName="items" 
                customTitle={notFound ? "404" : item.title ? item.title : ""} 
                customActionButtons={managePersmission ? [
                    {
                        icon: "delete",
                        variant: "text",
                        label: "Delete",
                        color: "error",
                        onClick: () => setSureToDeleteWindow(true)
                    },
                    {
                        icon: "edit",
                        variant: "text",
                        link: `/panel/items/edit/${item.id}`,
                        label: "edit",
                        color: "success"
                    }
                ] : []}
            />}

            {notFound && <SectionBoxContainer><NotFound message="Item doesn't exist." /></SectionBoxContainer>}
            {!notFound && <SingleItemContent item={item} usePublicDetails={usePublicDetails} />}

        </div>
    )
}